<template>
  <div class="availability-marker" :class="classes" :style="styles">
    <div class="availability-marker__ring" :style="{ animationDelay: animationDelay + 'ms' }"></div>
    <div class="availability-marker__dot"></div>
    <!-- <div class="availability-marker__count">{{ propertyCount }}</div> -->
  </div>
</template>
<script>
export default {
  props: ['animation-delay', 'available', 'filtered', 'property-count', 'x', 'y', 'status'],
  computed: {
    classes () {
      let classes = {}
      // Adjust the status conditions based on what you're expecting from the CRM - or better still: adjust the properties get request on the API to standardise to something like below
      classes['availability-marker--available'] = this.status === 'For Sale'
      classes['availability-marker--hold'] = this.status ===  'Hold' || this.status ===  'Hold - Pending Signing'
      classes['availability-marker--sold'] = this.status === 'Settled' || this.status === 'Sold' || this.status === 'Unconditional' || this.status === 'Conditional' || this.status === 'Signed Pending Deposit'
      classes['availability-marker--filtered'] = this.filtered
      return classes
    },

    styles () {
      return {
        left: (this.x / 20) + 'rem',
        top: (this.y / 20) + 'rem'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
$marker-color: #54a9ed;
//54a9ed
.availability-marker {

  padding: 2rem;
  position: absolute;
  transform: translate(-1rem, -1rem);

  &--hold {
    .availability-marker__dot {
      background-color: $dot-hold;
      opacity: 1;
    }
  }

  &--sold {
    .availability-marker__dot {
      background-color: $dot-sold;
      opacity: 1;
    }
  }

  &--available {
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $dot-available;
      opacity: 1;

    }

    .availability-marker__ring {
      border: 0.3rem solid $dot-available;
      border-radius: 3rem;
      height: 2rem;
      width: 2rem;
      position: absolute;
      animation: pulsate 2s ease-out;
      animation-iteration-count: infinite; 
      opacity: 0.0;
    }
  }

  &--filtered {
    .availability-marker__dot {
      //background-color: #858585;
      // opacity: 0;
    }

    .availability-marker__count {
      // opacity: 0;
    }
  }  

  &__dot {
    border-radius: 1rem;
    border: 0.2rem solid #fff;
    height: 2rem;
    transition: all 0.3s;
    width: 2rem;    
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);    
  }

  &__ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__count {
    background-color: rgba($white, 0.75);
    color: $black;
    font-size: 1.8rem;
    text-align: center;
    transition: all 0.3s;
    top: 100%;
    position: absolute;
    left: 50%;
    padding: 0 0.3em;
    transform: translateX(-50%);
    text-shadow:
    -1px -1px 0 $white,  
      1px -1px 0 $white,
      -1px 1px 0 $white,
      1px 1px 0 $white;
  }
}
</style>
